import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import MapView from "../views/MapView.vue";
import GridView from "../views/GridView.vue";
import VideoView from "../views/VideoView.vue";
import store from "../store/store";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "GridView",
    component: GridView,
  },
  {
    path: "/map",
    name: "MapView",
    component: MapView,
    beforeEnter(to, from, next) {
      next();
      // ...
    },
  },
  {
    path: "/video/:id",
    name: "VideoView",
    component: VideoView,
    beforeEnter(to, from, next) {
      const setVideo = () => {
        store
          .dispatch("setVideo", to.params.id)
          .then(() => next())
          .catch(() => next("/"));
      };
      /* If store is already populated */
      const videos = store.getters.getVideos.length
      if (videos > 0) setVideo();
      else {
        // Wait for the store to get populated
        store.watch(
          (state) => state.videos,
          (videos) => setVideo()
        );
      }
    },
  },
];

const router = new VueRouter({
  routes,
});

//router.push("/"); // Refreshing or reloading will navigate user to the default route
export default router;
